import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import cn from 'classnames';
import { InverseButton, PrimaryButton } from '@crehana/ui';
import { useResponsiveContext } from "../context/Responsive";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var buttonSizeByPlayerSize = {
  xxs: 'xs',
  xs: 's',
  sm: 'm',
  md: 'l',
  lg: 'l'
};
var OverlayMessage = function OverlayMessage(_ref) {
  var overlay = _ref.overlay,
    visible = _ref.visible,
    showOnMobile = _ref.showOnMobile;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var button = overlay.button,
    secondaryButton = overlay.secondaryButton,
    contentSize = overlay.contentSize,
    jsxBody = overlay.jsxBody,
    title = overlay.title,
    description = overlay.description;
  var isLgContentSize = contentSize === 'l';
  var visibleJsxBodyByPlayerSize = jsxBody === null || jsxBody === void 0 ? void 0 : jsxBody.visibleByPlayerSize;
  var shouldRenderJsxBody = (!visibleJsxBodyByPlayerSize || visibleJsxBodyByPlayerSize[playerSize.value]) && (jsxBody === null || jsxBody === void 0 ? void 0 : jsxBody.renderFn);
  var onPrimaryButtonClick = function onPrimaryButtonClick(event) {
    var _button$onClick;
    event.stopPropagation();
    button === null || button === void 0 ? void 0 : (_button$onClick = button.onClick) === null || _button$onClick === void 0 ? void 0 : _button$onClick.call(button);
  };
  var onSecondaryButtonClick = function onSecondaryButtonClick(event) {
    var _secondaryButton$onCl;
    event.stopPropagation();
    secondaryButton === null || secondaryButton === void 0 ? void 0 : (_secondaryButton$onCl = secondaryButton.onClick) === null || _secondaryButton$onCl === void 0 ? void 0 : _secondaryButton$onCl.call(secondaryButton);
  };
  var primaryButtonProps = button ? {
    label: button.label,
    onClick: button.onClick ? onPrimaryButtonClick : undefined,
    isDark: true,
    size: buttonSizeByPlayerSize[playerSize.value]
  } : undefined;
  var secondaryButtonProps = secondaryButton ? {
    label: secondaryButton.label,
    className: "mt-16 ".concat(isLgContentSize ? 'lg:mt-0 lg:mr-24' : ''),
    onClick: secondaryButton.onClick ? onSecondaryButtonClick : undefined,
    isWhite: true,
    isDark: true,
    size: buttonSizeByPlayerSize[playerSize.value]
  } : undefined;
  if (!showOnMobile && !playerSize.matches.md) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: cn('absolute inset-0 flex flex-col items-center text-center bg-base-main-80 text-white', shouldRenderJsxBody ? 'justify-end' : 'justify-center', visible ? 'cui-is-visible' : 'cui-is-hidden'),
    children: [title && /*#__PURE__*/_jsx("h3", {
      className: isLgContentSize ? 'font-h2 mb-24' : 'font-h3-md mb-16',
      children: title
    }), description && playerSize.matches.xs && /*#__PURE__*/_jsx("p", {
      className: isLgContentSize ? 'font-subtitle1 mb-32' : 'font-subtitle3 mb-24',
      style: {
        maxWidth: isLgContentSize ? '680px' : '470px'
      },
      children: description
    }), /*#__PURE__*/_jsxs("div", {
      className: cn('flex flex-col', isLgContentSize ? ' lg:flex-row-reverse' : ''),
      children: [primaryButtonProps && /*#__PURE__*/_jsx(PrimaryButton, _objectSpread({}, primaryButtonProps)), secondaryButtonProps && /*#__PURE__*/_jsx(InverseButton, _objectSpread({}, secondaryButtonProps))]
    }), shouldRenderJsxBody && (jsxBody === null || jsxBody === void 0 ? void 0 : jsxBody.renderFn) && /*#__PURE__*/_jsxs("div", {
      className: "my-8",
      children: [" ", jsxBody.renderFn(), " "]
    })]
  });
};
export default OverlayMessage;